// extracted by mini-css-extract-plugin
export default {"categoryTabs":"categoryTabs-module__DmNlq","categoryTab":"categoryTabs-module__YZ51j","categoryTabActive":"categoryTabs-module__aKiEQ"};